import { CASAMAPA_PARTNER_VENDOR_SECTIONS } from "./casamapaPartnerVendorPaths.js";

export const VENDOR_DIRECTORY_NAV_GROUPS = [
  {
    id: "intake",
    labelKey: "realEstate.casaMapa.admin.vendors.pipeline.groups.intake",
    items: [
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.candidates,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.candidates",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.candidatesHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.imports,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.imports",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.importsHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.collectionRuns,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.discovery",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.discoveryHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.collectionPlans,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.collectionPlans",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.collectionPlansHint",
      },
    ],
  },
  {
    id: "review",
    labelKey: "realEstate.casaMapa.admin.vendors.pipeline.groups.review",
    items: [
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.duplicates,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.duplicates",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.duplicatesHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.verification,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.verification",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.verificationHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.credentials,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.credentials",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.credentialsHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.vendors,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.allVendors",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.allVendorsHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.vendorCreate,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.createVendor",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.createVendorHint",
      },
    ],
  },
  {
    id: "requests",
    labelKey: "realEstate.casaMapa.admin.vendors.pipeline.groups.requests",
    items: [
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.claims,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.claims",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.claimsHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.privacy,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.privacy",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.privacyHint",
      },
    ],
  },
  {
    id: "directory",
    labelKey: "realEstate.casaMapa.admin.vendors.pipeline.groups.directory",
    items: [
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.sources,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.sources",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.sourcesHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.ranking,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.ranking",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.rankingHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.analytics,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.analytics",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.analyticsHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.maintenance,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.maintenance",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.maintenanceHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.pilot,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.pilot",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.pilotHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.expansion,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.expansion",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.expansionHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.marketplace,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.marketplace",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.marketplaceHint",
      },
      {
        segment: CASAMAPA_PARTNER_VENDOR_SECTIONS.settings,
        labelKey: "realEstate.casaMapa.admin.vendors.pipeline.settings",
        hintKey: "realEstate.casaMapa.admin.vendors.pipeline.settingsHint",
      },
    ],
  },
];

const SUB_ROUTE_LABEL_KEYS = {
  [CASAMAPA_PARTNER_VENDOR_SECTIONS.imports + "/nuevo"]:
    "realEstate.casaMapa.admin.vendorDirectoryWorkspace.breadcrumbs.newImport",
  [CASAMAPA_PARTNER_VENDOR_SECTIONS.vendorCreate]:
    "realEstate.casaMapa.admin.vendors.pipeline.createVendor",
  [CASAMAPA_PARTNER_VENDOR_SECTIONS.privacyRetention]:
    "realEstate.casaMapa.admin.vendorDirectoryWorkspace.breadcrumbs.retention",
  [CASAMAPA_PARTNER_VENDOR_SECTIONS.maintenance + "/tareas"]:
    "realEstate.casaMapa.admin.vendorDirectoryWorkspace.maintenancePage.nav.queue",
  [CASAMAPA_PARTNER_VENDOR_SECTIONS.maintenance + "/politicas"]:
    "realEstate.casaMapa.admin.vendorDirectoryWorkspace.maintenancePage.nav.policies",
  [CASAMAPA_PARTNER_VENDOR_SECTIONS.maintenance + "/trabajos"]:
    "realEstate.casaMapa.admin.vendorDirectoryWorkspace.maintenancePage.nav.jobs",
  [CASAMAPA_PARTNER_VENDOR_SECTIONS.maintenance + "/fallos"]:
    "realEstate.casaMapa.admin.vendorDirectoryWorkspace.maintenancePage.nav.failures",
};

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const VENDOR_WORKSPACE_NAV_STORAGE_KEY = "midpoint.vendorWorkspace.navExpanded";

function segmentRoot(segment) {
  return String(segment || "").split("/")[0];
}

export function findGroupIdForSegment(activeSegment) {
  if (!activeSegment) {
    return VENDOR_DIRECTORY_NAV_GROUPS[0].id;
  }

  const activeRoot = segmentRoot(activeSegment);
  for (const group of VENDOR_DIRECTORY_NAV_GROUPS) {
    const matches = group.items.some((item) => {
      const itemRoot = segmentRoot(item.segment);
      return (
        activeRoot === itemRoot ||
        activeSegment === item.segment ||
        activeSegment.startsWith(`${itemRoot}/`) ||
        String(item.segment).startsWith(`${activeSegment}/`)
      );
    });
    if (matches) {
      return group.id;
    }
  }

  return VENDOR_DIRECTORY_NAV_GROUPS[0].id;
}

function findNavMatch(relativePath) {
  const normalized = String(relativePath || "").replace(/^\/+|\/+$/g, "");
  if (!normalized) {
    return null;
  }

  let best = null;
  for (const group of VENDOR_DIRECTORY_NAV_GROUPS) {
    for (const item of group.items) {
      const segment = item.segment;
      if (normalized === segment || normalized.startsWith(`${segment}/`)) {
        if (!best || segment.length > best.item.segment.length) {
          best = {
            group,
            item,
            remainder: normalized.slice(segment.length).replace(/^\//, ""),
          };
        }
      }
    }
  }

  return best;
}

function humanizeSegment(segment) {
  return String(segment || "")
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function labelForPathSegment(pathSoFar, segment, t) {
  const labelKey = SUB_ROUTE_LABEL_KEYS[pathSoFar];
  if (labelKey) {
    return t(labelKey);
  }
  if (UUID_RE.test(segment)) {
    return t("realEstate.casaMapa.admin.vendorDirectoryWorkspace.breadcrumbs.record");
  }
  return humanizeSegment(segment);
}

export function buildVendorDirectoryBreadcrumbs({
  relativePath,
  t,
  hubPathBuilder,
  clientViewId,
  dashboardPath,
  dashboardLabel,
}) {
  const crumbs = [{ label: dashboardLabel, to: dashboardPath }];
  const match = findNavMatch(relativePath);

  if (!match) {
    const fallback = String(relativePath || "").replace(/^\/+|\/+$/g, "");
    if (fallback) {
      crumbs.push({ label: humanizeSegment(fallback.split("/")[0]), to: null, current: true });
    }
    return crumbs;
  }

  crumbs.push({ label: t(match.group.labelKey), to: null });
  crumbs.push({
    label: t(match.item.labelKey),
    to: hubPathBuilder(clientViewId, match.item.segment),
  });

  if (!match.remainder) {
    crumbs[crumbs.length - 1].current = true;
    crumbs[crumbs.length - 1].to = null;
    return crumbs;
  }

  const parts = match.remainder.split("/").filter(Boolean);
  let pathAcc = match.item.segment;

  parts.forEach((part, index) => {
    pathAcc = `${pathAcc}/${part}`;
    const isLast = index === parts.length - 1;
    crumbs.push({
      label: labelForPathSegment(pathAcc, part, t),
      to: isLast ? null : hubPathBuilder(clientViewId, pathAcc),
      current: isLast,
    });
  });

  return crumbs;
}
